<template>
    <div id="index">
      <h2>404！</h2>
      <p>真不巧，页面走丢了~~~</p>
      <!-- <el-button @click="handlerHone" type="primary">返回首页</el-button> -->
    </div>
  </template>
  <script>
  export default {
    data() {
      return {};
    },
    methods: {
      handlerHone() {
          this.$router.push('/index');
      },
    },
  };
  </script>
  <style>
  .el-main {
    padding: 0;
  }
  </style>
  <style lang="less" scoped>
  #index {
    height: 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    h2 {
      font-size: 120px;
      color: #00a4ef;
      font-weight: bolder;
      text-shadow: 0 0 10px #000;
      font-family: "华文楷体";
    }
    p {
      font-size: 20px;
      margin: 20px 0 0 110px;
      text-shadow: 2px 2px 2px #e63d00;
    }
    button {
      margin-top: 20px;
    }
  }
  </style>